export enum RouteNames {
  InferenceMonitoring = 'InferenceMonitoring'
}
